import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { BehaviorSubject, Observable } from 'rxjs';
// import { map } from 'rxjs/operators';
import { API_MACHINE_URL} from '../../connection.data';
// import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// import { formatDate } from '../../_base/util/date.util';
// import { Machine, MachineTechType, MachineType } from '../_models/machine.model';
// import { Shift } from '../_models/shift.model';
import { BasicService } from './basic.service';
import { Observable } from 'rxjs';
import { toHttpParams } from '../../_base/util/request.util';
import { map } from 'rxjs/operators';
//const API_USERS_URL = 'api/users';
//const API_PERMISSION_URL = 'api/permissions';
//const API_ROLES_URL = 'api/roles';

//const BASE_URL = "http://localhost:3000"                //INTERNAL DEV
//const BASE_URL = "http://ir4hub.cl:45016"                //LAB DEV

@Injectable()
export class MachineService extends BasicService{
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_MACHINE_URL;
    }

    // getOperators(machineId: number):Observable<Machine[]>{
    //     const url = `${API_MACHINE_URL}/operators/${machineId}`;
    //     return this.http.get<{rows: any, status: string}>(url).pipe(
    //         map((response)=>{
    //             return response.rows;
    //         })
    //     )
    // }

    // getAllWithShifts():Observable<Machine[]>{
    //     const url = `${API_MACHINE_URL}/all/shifts`;
    //     return this.http.get<{rows: any, status: string}>(url).pipe(
    //         map((response)=>{
    //             return response.rows;
    //         })
    //     )
    // }

    // getOperatingAtShift(shift):Observable<Machine[]>{
    //     const url = `${API_MACHINE_URL}/operating/shift/${shift.id}`;
    //     return this.http.get<{rows: any, status: string}>(url).pipe(
    //         map((response)=>{
    //             return response.rows;
    //         })
    //     )
    // }

    getOperating(options:any = {}):Observable<any[]>{
        const httpParams: HttpParams = toHttpParams(options);
				const urlMap = {
					'normal': `${API_MACHINE_URL}/operating`,
					'date': `${API_MACHINE_URL}/operating/date`,
					'range': `${API_MACHINE_URL}/operating/date/range`,
				}
        let url = urlMap['normal'];
				if(options['date']) url = urlMap['date'];
				if(options['st']) url = urlMap['range'];
        return this.http.get<any>(url, {params: httpParams}).pipe(
            // map((response)=>{
            //     return response.rows;
            // })
        )
    }

    getByIds(ids): Observable<any[]>{
        return this.http.post(`${this.baseUrl}/ids`, {ids}).pipe(
            map((resp:any)=>resp.rows)
        )
    }

    getAllLight():Observable<any[]>{
        const url = `${this.baseUrl}/all/light`;
        return this.http.get<{rows: any, status: string}>(url).pipe(
            map((response)=>{
                return response.rows;
            })
        )
    }

    relay(options:any = {}):Observable<any[]>{
        const httpParams: HttpParams = toHttpParams(options);
        const url = `${API_MACHINE_URL}/relay`;
        return this.http.get<any>(url, {params: httpParams}).pipe(
            // map((response)=>{
            //     return response.rows;
            // })
        )
    }

    // getOperatingAt(date):Observable<Machine[]>{

    //     const url = `${API_MACHINE_URL}/operating?date=${encodeURIComponent(formatDate(date))}`;
    //     return this.http.get<{rows: any, status: string}>(url).pipe(
    //         map((response)=>{
    //             return response.rows;
    //         })
    //     )
    // }

    // getCurrentShift(machine:Machine):Observable<Shift>{
    //     const url = `${API_MACHINE_URL}/shift/current/${machine.id}`;
    //     return this.http.get<{rows: any, status: string}>(url).pipe(
    //         map((response)=>{
    //             return response.rows;
    //         })
    //     )
    // }

//     getTypes():Observable<MachineType[]>{
//         const url = `${API_MACHINE_URL}/types`;
//         return this.http.get<{rows: any, status: string}>(url).pipe(
//             map((response)=>{
//                 return response.rows;
//             })
//         )
//     }

//     getTechTypes():Observable<MachineTechType[]>{
//         const url = `${API_MACHINE_URL}/tech/types`;
//         return this.http.get<{rows: any, status: string}>(url).pipe(
//             map((response)=>{
//                 return response.rows;
//             })
//         )
//     }

//     getShifts(machine:Machine):Observable<Shift[]>{
//         const url = `${API_MACHINE_URL}/shifts/${machine.id}`;
//         return this.http.get<{rows: any, status: string}>(url).pipe(
//             map((response)=>{
//                 return response.rows;
//             })
//         )
//     }
}
